export default __webpack_public_path__ + "static/media/submit.c3008dba.png";